import { render } from "./SpinnerLoading.vue?vue&type=template&id=24658b0c&scoped=true"
const script = {}

import "./SpinnerLoading.vue?vue&type=style&index=0&id=24658b0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24658b0c"]])

export default __exports__